import React from 'react';
import translate from 'i18n/translate';
import TeamMembers from 'components/TeamMembers/index';
import Structure from './Structure';

const StructurePage = () => {
  return (
    <div className="center-container">
      <div className=" goals-box-margin">
        <div>
          <div className="text-box-title">
            <h1>{translate('organisationStructure')}</h1>
            <hr className="text-box-title-line" />
          </div>
          <div className="goals-box-content structure-content">
            <div className="mt-4 mr-4 structure-image">
              <Structure></Structure>
            </div>
          </div>
        </div>
        <TeamMembers></TeamMembers>
      </div>
    </div>
  );
};

export default StructurePage;
